import { ChangeEvent, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import {
  getWebPageVariant,
  WebPageType,
} from '../../../../constants/webPageType';
import {
  LoadingSpinner,
  SvgIcon,
  TextButton,
  TextButtonSize,
  TextInput,
} from '../../../Molecules';

import styles from './EmailAndPasswordTemplate.module.css';

type TextInputProps = {
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

type RegisterTemplateProps = {
  email: TextInputProps;
  password: TextInputProps;
  confirmPassword: TextInputProps;
  isClicked: boolean;
  errorMessage: string;
  isLoading: boolean;
  webPageType: WebPageType;
  onClick: () => void;
  onClickBack: () => void;
};

export const EmailAndPasswordTemplate = memo(
  ({
    email,
    password,
    confirmPassword,
    isClicked,
    errorMessage,
    isLoading,
    webPageType,
    onClick,
    onClickBack,
  }: RegisterTemplateProps) => {
    const { t } = useTranslation();
    return (
      <div className={styles.emailPassword}>
        <div className={styles.centeredContainer}>
          <button className={styles.backButton} onClick={onClickBack}>
            <SvgIcon
              name={SVGIconType.Arrow}
              color="black"
              width={24}
              height={24}
            />
          </button>
          <p
            className={`${styles.title} ${
              styles[getWebPageVariant(webPageType).classVariantLight2]
            }`}
          >
            {t('Email & Password')}
          </p>
          <div className={styles.inputs}>
            <TextInput
              value={email.value}
              onChange={email.onChange}
              placeholder={t('Email')}
              isClicked={isClicked}
              style={{ backgroundColor: '#f0f0f0' }}
            />
            <TextInput
              value={password.value}
              onChange={password.onChange}
              placeholder={t('Password')}
              isClicked={isClicked}
              type="password"
              style={{ backgroundColor: '#f0f0f0' }}
            />
            <TextInput
              value={confirmPassword.value}
              onChange={confirmPassword.onChange}
              placeholder={t('Confirm Password')}
              isClicked={isClicked}
              type="password"
              style={{ backgroundColor: '#f0f0f0' }}
            />
          </div>
          <div className={styles.warning}>{t(errorMessage)}</div>
          <TextButton
            text={t('Confirm')}
            size={TextButtonSize.Medium}
            variant={getWebPageVariant(webPageType).textButtonVariant}
            onClick={onClick}
            disabled={
              !email ||
              email.value.trim().length < 1 ||
              password.value.trim().length < 1
            }
          />
        </div>
        {isLoading && <LoadingSpinner loading={isLoading} />}
      </div>
    );
  },
);
